import React from 'react';

export const MagnifierColored = () => (
  <svg
    width={'43'}
    height={'43'}
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41.4511 38.0892L37.5859 41.9555L27.6619 32.0303L31.5896 28.229L41.4511 38.0892Z"
      stroke="#297FFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.8844 1.95557C22.2454 1.95557 26.4278 3.68789 29.5116 6.77147C32.5954 9.85506 34.3281 14.0373 34.3284 18.3983C34.3284 22.7595 32.5959 26.9421 29.512 30.026C26.4282 33.1098 22.2456 34.8423 17.8844 34.8423C13.5232 34.8423 9.34059 33.1098 6.25675 30.026C3.17291 26.9421 1.44043 22.7595 1.44043 18.3983C1.44074 14.0373 3.17338 9.85506 6.25719 6.77147C9.34099 3.68789 13.5234 1.95557 17.8844 1.95557V1.95557Z"
      stroke="#297FFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.7283 6.61377C20.8842 6.61377 23.911 7.86739 26.1427 10.0989C28.3744 12.3304 29.6283 15.357 29.6286 18.5129"
      stroke="#2ED3B7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
